/*INFO this is truncate hook to truncate at the middle of text*/
import { useResizeObserver } from '@mantine/hooks';
import { useMemo } from 'react';

type Options = {
	maxLines?: number;
	avgCharWidth?: number;
};

export const middleTruncate = (text: string, maxChars: number) => {
	if (text.length <= maxChars) {
		return text;
	}
	if (maxChars <= 4) {
		return '…';
	}
	if (maxChars <= 7) {
		return `${text.slice(0, Math.max(1, maxChars - 1))}…`;
	}
	const keep = Math.floor((maxChars - 1) / 2);
	return `${text.slice(0, keep)}…${text.slice(-keep)}`;
};

export const useAutoMiddleEllipsis = (
	text: string,
	{ maxLines = 2, avgCharWidth = 8.5 }: Options = {}
) => {
	const [ref, rect] = useResizeObserver();

	const displayedText = useMemo(() => {
		const width = rect?.width ?? 0;

		if (!width) {
			return text;
		}

		const charsPerLine = Math.max(1, Math.floor(width / avgCharWidth));
		const maxChars = charsPerLine * maxLines;
		return middleTruncate(text, maxChars);
	}, [text, rect?.width, avgCharWidth, maxLines]);

	return { ref, text: displayedText };
};
